<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <form
      class="w-100"
      style="margin-top: 82px; padding: 24px"
      @submit.prevent="editUser"
    >
      <span class="pageSteps card-styling">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>
        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-style: normal; font-weight: 500">Editar Perfil</p>
      </span>

      <section
        style="margin-top: 24px"
        class="d-flex flex-column justify-content-between align-items-center w-100"
      >
        <div class="card-styling d-flex w-100 session-one">
          <section
            class="w-100 d-flex flex-column justify-content-between align-items-start bl-dados"
          >
            <h6 style="margin-bottom: 32px">Dados Pessoais</h6>

            <div class="d-flex w-100" style="height: -webkit-fill-available">
              <div
                class="w-100 d-flex flex-column align-items-center justify-content-between"
              >
                <Input
                  :inputValue="user.name"
                  :inputType="'text'"
                  :inputLabel="'Nome'"
                  :inputTypeNotValidation="true"
                  @onUpdate="(value) => validateInputLetters(value)"
                />
                <Input
                  :inputValue="user.email"
                  :inputType="'email'"
                  :inputLabel="'E-mail'"
                  :inputTypeNotValidation="false"
                  :justView="true"
                  :disabled="true"
                />
              </div>
            </div>
          </section>

          <section
            class="w-100 d-flex flex-column justify-content-between align-items-start bl-status"
          >
            <div
              class="w-100 d-flex align-items-center justify-content-between"
              style="margin-top: 8px"
            >
              <p>Status</p>
              <button
                type="button"
                class="btn-no-width"
                :class="user.isActive === 'Ativo' ? 'btnRed' : 'btnGreen'"
                data-bs-toggle="modal"
                data-bs-target="#modalDesativarAtivar"
              >
                {{ user.isActive === "Ativo" ? "Desativar" : "Ativar" }}
              </button>
            </div>
            <p style="margin-left: 3%">{{ user.isActive }}</p>
            <span class="w-100 align-items-center justify-content-between">
              <p>Criado em</p>
              <p style="margin-left: 3%">
                {{ currentDate(user.createdAt) }}
                {{ currentHour(user.createdAt) }}
              </p>
            </span>
          </section>
        </div>

        <div class="card-styling" style="margin-top: 24px">
          <section
            class="d-flex w-100 justify-content-between align-items-center flex-wrap"
          >
            <h6 style="margin-bottom: 32px">Loja Associadas</h6>
            <div class="d-flex align-items-center" style="gap: 8px">
              <button
                v-if="associatedRoles.length > 0"
                class="btnPrimaryWhite"
                @click.prevent="toggleSelectAllAssociated"
              >
                {{ allAssociatedSelected ? "Remover Todos" : "Selecionar Todos" }}
              </button>
              <div style="width: 310px">
                <InputSearch @onUpdate="(value) => getStoreByName(value, true)" />
              </div>
            </div>
          </section>
          <section
            class="d-flex w-100 justify-content-center align-items-center table-responsive"
          >
            <div class="table-responsive w-100">
              <table class="table align-middle">
                <thead class="thead">
                  <tr style="height: 50px">
                    <th>Nome</th>
                    <th>Associado</th>
                    <th>Desassociar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="role in associatedRoles" :key="role">
                    <td>{{ role }}</td>
                    <td>Sim</td>
                    <th>
                      <input
                        v-if="
                          storeIsChecked(
                            role,
                            rolesToDisassociate,
                            'rolesToDisassociate'
                          )
                        "
                        type="checkbox"
                        :name="'dessassociar' + role"
                        id=""
                        checked
                        @click="clickDisassociated($event.target.checked, role)"
                      />
                      <input
                        v-else
                        type="checkbox"
                        :name="'dessassociar' + role"
                        id=""
                        @click="clickDisassociated($event.target.checked, role)"
                      />
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <Pagination
            :count="totalAssociatedRoles"
            :offset="offset"
            @firstPage="pagination('clickFirstPage', true)"
            @previousPage="pagination('clickPreviousPage', true)"
            @nextPage="pagination('clickNextPage', true)"
            @lastPage="pagination('clickLastPage', true)"
          />
        </div>

        <div class="card-styling" style="margin: 24px 0">
          <section
            class="d-flex w-100 justify-content-between align-items-center flex-wrap"
          >
            <h6 style="margin-bottom: 32px">Loja Desassociadas</h6>
            <div class="d-flex align-items-center" style="gap: 8px">
              <button
                v-if="disassociatedRoles.length > 0"
                class="btnPrimaryWhite"
                @click.prevent="toggleSelectAllDisassociated"
              >
                {{ allDisassociatedSelected ? "Remover Todos" : "Selecionar Todos" }}
              </button>
              <div style="width: 310px">
                <InputSearch
                  @onUpdate="(value) => getStoreByName(value, false)"
                />
              </div>
            </div>
          </section>
          <section
            class="d-flex w-100 justify-content-center align-items-center table-responsive"
          >
            <div class="table-responsive w-100">
              <table class="table align-middle">
                <thead class="thead">
                  <tr style="height: 50px">
                    <th>Nome</th>
                    <th>Associado</th>
                    <th>Associar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="role in disassociatedRoles" :key="role">
                    <td>{{ role }}</td>
                    <td>Não</td>
                    <th>
                      <input
                        v-if="
                          storeIsChecked(
                            role,
                            rolesToAssociate,
                            'rolesToAssociate'
                          )
                        "
                        type="checkbox"
                        :name="'associar' + role"
                        id=""
                        checked
                        @click="clickAssociated($event.target.checked, role)"
                      />
                      <input
                        v-else
                        type="checkbox"
                        :name="'associar' + role"
                        id=""
                        @click="clickAssociated($event.target.checked, role)"
                      />
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <Pagination
            :count="totalDisassociatedRoles"
            :offset="offset"
            @firstPage="pagination('clickFirstPage', false)"
            @previousPage="pagination('clickPreviousPage', false)"
            @nextPage="pagination('clickNextPage', false)"
            @lastPage="pagination('clickLastPage', false)"
          />
        </div>

        <footer
          class="card-styling d-flex align-items-center justify-content-end"
        >
          <div class="d-flex align-items-center" style="width: 60%">
            <button
              type="button"
              style="
                background-color: var(--blue-light);
                color: var(--blue-medium);
                margin: 8px;
              "
              :to="{ name: 'Users' }"
              class="btn-default text-center text-decoration-none"
            >
              <router-link
                style="text-decoration: none"
                :to="{ name: 'Users' }"
              >
                Voltar
              </router-link>
            </button>
            <button
              class="btn-default"
              type="submit"
              style="
                background-color: var(--blue-medium);
                color: var(--white);
                margin: 8px;
              "
            >
              Salvar
            </button>
          </div>
        </footer>
      </section>
    </form>

    <!-- Modal Desativar/Ativar -->
    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalDesativarAtivar"
      tabindex="1"
      aria-labelledby="modalDesativarAtivar"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <form
        class="modal-dialog modal-dialog-centered"
        @submit.prevent="disableUser(user.isActive)"
      >
        <div
          class="modal-content"
          :class="user.isActive === 'Ativo' ? 'disassociate' : 'associate'"
        >
          <div class="modal-header border-0 pb-0">
            <h6
              class="modal-title"
              style="
                font-style: normal;
                font-weight: 700;
                font-size: 27px;
                color: #383838;
              "
            >
              Tem certeza?
            </h6>
          </div>
          <div class="modal-body mt-0 pt-0">
            <p
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: #80848a;
              "
            >
              Ao continuar, esse usuário será
              {{ user.isActive === "Ativo" ? "desativado" : "ativado" }} do
              sistema e {{ user.isActive === "Ativo" ? "não" : "" }} poderá
              {{ user.isActive === "Ativo" ? "mais" : "" }} realizar login e
              gerenciar as lojas associadas a ele(a).
            </p>
          </div>
          <div
            class="d-flex w-100 justify-content-center align-items-center"
            style="padding: 12px"
          >
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                background-color: var(--blue-light);
                color: var(--blue-medium);
                margin: 8px;
              "
              class="btn-default"
            >
              Não, Voltar
            </button>
            <button
              type="submit"
              :class="
                user.isActive === 'Ativo' ? 'btnDisassociate' : 'btnAssociate'
              "
              style="color: var(--white); margin: 8px"
              class="btn-default"
            >
              Sim,
              {{ user.isActive === "Ativo" ? "desativar" : "ativar" }} usuário
            </button>
          </div>
        </div>
      </form>
    </div>
    <!-- Modal concluido -->
    <div
      class="modal fade"
      data-bs-backdrop="true"
      id="modalTemplateExcluido"
      tabindex="1"
      aria-labelledby="modalTemplateExcluido"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered justify-content-center">
        <div
          class="modal-content justify-conter-center"
          style="
            border-top: 8px solid var(--blue-medium);
            max-width: 385px;
            padding: 7%;
          "
        >
          <div class="modal-header border-0 pb-0 w-100">
            <h6
              class="modal-title w-100"
              style="
                font-style: normal;
                font-weight: 700;
                font-size: 27px;
                color: #383838;
              "
            >
              Usuário
              {{ user.isActive === "Ativo" ? "ativado" : "desativado" }}!
            </h6>
          </div>
          <div class="modal-body mt-0 pt-0">
            <p
              style="
                font-style: normal;
                font-weight: 400;
                color: var(--grey-medium);
                font-size: 16px;
                margin: 0;
              "
            >
              O acesso ao gerenciador social foi revogado ao usuário
              {{ user.name }}. A partir desse momento ele(a)
              {{ user.isActive === "Ativo" ? "" : "não" }} poderá
              {{ user.isActive === "Ativo" ? "" : "mais" }} fazer login no
              sistema.
            </p>
          </div>
          <div
            class="d-flex w-100 justify-content-center align-items-center"
            style="padding: 12px"
          >
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                background-color: transparent;
                margin: 8px;
                color: var(--blue-medium);
              "
              class="btn-default"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
    <input
      type="hidden"
      id="clickModalTemplateExcluido"
      data-bs-toggle="modal"
      data-bs-target="#modalTemplateExcluido"
    />
  </div>
</template>
<script>
import Input from "@/components/Input.vue";
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import formatting from "../plugins/formatting";
import apiGerenciarMidiasService from "../service/apiGerenciarMidiasService";
import Loading from "vue-loading-overlay";
import moment from "moment";

export default {
  name: "EditUser",
  components: {
    Input,
    InputSearch,
    Pagination,
    Loading,
  },
  data() {
    return {
      user: {
        name: "",
        email: "",
      },
      rolesToAssociate: [],
      rolesToDisassociate: [],
      associatedRoles: [],
      disassociatedRoles: [],
      offset: 0,
      totalAssociatedRoles: 0,
      totalDisassociatedRoles: 0,
      nameToSearch: "",
      isLoading: false,
    };
  },
  async created() {
    this.isLoading = true;

    await this.getUser();

    this.isLoading = false;
  },
  computed: {
    ...mapGetters(["getOffset"]),
    allAssociatedSelected() {
      // Verifica se TODAS as lojas associadas (de todas as páginas) estão selecionadas para remoção
      return (
        this.totalAssociatedRoles > 0 &&
        this.rolesToDisassociate.length === this.totalAssociatedRoles
      );
    },
    allDisassociatedSelected() {
      // Verifica se TODAS as lojas desassociadas (de todas as páginas) estão selecionadas para associação
      return (
        this.totalDisassociatedRoles > 0 &&
        this.rolesToAssociate.length === this.totalDisassociatedRoles
      );
    },
  },
  methods: {
    ...mapActions([
      "getUserDataByEmail",
      "updateAnotherUser",
      "putDisableUser",
      "putRemoveRole",
      "adduserRole",
      "getListUserRoleByPagination",
    ]),
    ...mapMutations(["SET_OFFSET"]),

    async editUser() {
      this.isLoading = true;
      try {
        const response = await this.updateAnotherUser({
          name: this.user.name,
          email: this.user.email,
        });
        if (response.status === 200) {
          await this.disassociate();
          await this.associate();
          await this.getUser();
          this.rolesToDisassociate = [];
          this.rolesToAssociate = [];
          this.isLoading = false;
        } else {
          console.log("Não foi possível alterar esse usuário!");
          this.isLoading = false;
        }
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }
    },
    validateInputLetters(value) {
      this.user.name = value.replace(
        /[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]/g,
        ""
      );
    },
    currentDate(timestamp) {
      return moment(timestamp)
        .locale("pt-br")
        .subtract(3, "hour")
        .format("DD/MM/YYYY");
    },
    currentHour(timestamp) {
      return moment(timestamp).locale("pt-br").subtract(3, "hour").format("LT");
    },
    async disableUser(isDisable) {
      this.isLoading = true;

      isDisable = isDisable === "Ativo" ? true : false;

      try {
        const response = await this.putDisableUser({
          email: this.user.email,
          disable: isDisable,
        });

        if (response.status === 200) {
          await this.getUser();
          this.isLoading = false;
          document.getElementById("clickModalTemplateExcluido").click();
        } else {
          console.log("Não foi possivel desativar/ativar usuario");
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async disassociate() {
      if (this.rolesToDisassociate.length > 0) {
        try {
          const params = formatting.formatListInQueryStringFormat(
            this.rolesToDisassociate,
            "role"
          );

          const response = await this.putRemoveRole({
            email: this.user.email,
            roles: params,
          });

          if (response.status === 200) {
            console.log("Role(es) desassociada(as)!");
          } else {
            console.log("Não foi possivel desassociar essa(as) role(es)");
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async associate() {
      if (this.rolesToAssociate.length > 0) {
        try {
          const params = formatting.formatListInQueryStringFormat(
            this.rolesToAssociate,
            "roles"
          );

          const response = await this.adduserRole({
            email: this.user.email,
            roles: params,
          });

          if (response.status === 200) {
            console.log("Role(es) associada(as)!");
          } else {
            console.log("Não foi possivel associar essa(as) role(es)!");
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getUser() {
      try {
        const response = await this.getUserDataByEmail({
          email: this.$route.params.email,
        });
        if (response.status === 200) {
          this.user = response.data.data[0];
          await this.getAllAssociatedRoles();
          await this.getAllDisassociatedRoles();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAllDisassociatedRoles() {
      try {
        const response = await this.getListUserRoleByPagination({
          action: "clickFirstPage",
          email: this.$route.params.email,
          name: this.nameToSearch,
          offset: 0,
          limit: 5,
          rolesAssociates: false,
        });

        if (response.status === 200) {
          this.totalDisassociatedRoles = response.data.count;
          this.disassociatedRoles = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAllAssociatedRoles() {
      try {
        const response = await this.getListUserRoleByPagination({
          action: "clickFirstPage",
          email: this.$route.params.email,
          name: this.nameToSearch,
          offset: 0,
          limit: 5,
          rolesAssociates: true,
        });

        if (response.status === 200) {
          this.totalAssociatedRoles = response.data.count;
          this.associatedRoles = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    clickDisassociated(checked, id, name) {
      const arr = formatting.isSelected(
        checked,
        id,
        name,
        this.rolesToDisassociate
      );

      this.rolesToDisassociate = arr;
    },
    clickAssociated(checked, id, name) {
      const arr = formatting.isSelected(
        checked,
        id,
        name,
        this.rolesToAssociate
      );

      this.rolesToAssociate = arr;
    },
    async toggleSelectAllAssociated() {
      // Alterna entre selecionar todos e remover todos
      if (this.allAssociatedSelected) {
        // Se todos estão selecionados, remove todos
        this.rolesToDisassociate = [];
      } else {
        // Busca TODAS as lojas associadas (sem paginação) e seleciona todas
        try {
          const response = await this.getListUserRoleByPagination({
            action: "clickFirstPage",
            email: this.$route.params.email,
            name: this.nameToSearch,
            offset: 0,
            limit: this.totalAssociatedRoles,
            rolesAssociates: true,
          });

          if (response.status === 200) {
            this.rolesToDisassociate = [...response.data.data];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async toggleSelectAllDisassociated() {
      // Alterna entre selecionar todos e remover todos
      if (this.allDisassociatedSelected) {
        // Se todos estão selecionados, remove todos
        this.rolesToAssociate = [];
      } else {
        // Busca TODAS as lojas desassociadas (sem paginação) e seleciona todas
        try {
          const response = await this.getListUserRoleByPagination({
            action: "clickFirstPage",
            email: this.$route.params.email,
            name: this.nameToSearch,
            offset: 0,
            limit: this.totalDisassociatedRoles,
            rolesAssociates: false,
          });

          if (response.status === 200) {
            this.rolesToAssociate = [...response.data.data];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    storeIsChecked(id, arr, nameList) {
      if (arr.length > 0) {
        if (arr.includes(id)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    pagination(action, isAssociated) {
      const data = {
        action: action,
        email: this.$route.params.email,
        name: this.nameToSearch,
        offset: 0,
        limit: 5,
        rolesAssociates: isAssociated,
      };

      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getListUserRoleByPagination(data).then((response) => {
            if (isAssociated) {
              this.totalAssociatedRoles = response.data.count;
              this.associatedRoles = response.data.data;
            } else {
              this.totalDisassociatedRoles = response.data.count;
              this.disassociatedRoles = response.data.data;
            }
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - 5);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getListUserRoleByPagination(data).then((response) => {
            if (isAssociated) {
              this.associatedRoles = response.data.data;
            } else {
              this.disassociatedRoles = response.data.data;
            }
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + 5);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getListUserRoleByPagination(data).then((response) => {
            if (isAssociated) {
              this.associatedRoles = response.data.data;
            } else {
              this.disassociatedRoles = response.data.data;
            }
          });
          break;
        }
        case "clickLastPage": {
          this.SET_OFFSET(
            Math.floor(
              isAssociated
                ? this.totalAssociatedRoles
                : this.totalDisassociatedRoles / 5
            ) * 5
          );
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getListUserRoleByPagination(data).then((response) => {
            if (isAssociated) {
              this.associatedRoles = response.data.data;
            } else {
              this.disassociatedRoles = response.data.data;
            }
          });
          break;
        }
        default:
          break;
      }
    },
    getStoreByName: function getStoreByName(name, isAssociated) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage", isAssociated);
        }, 500);
      } else {
        this.pagination("clickFirstPage", isAssociated);
      }
    },
  },
};
</script>
<style scoped>
h6 {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: var(--grey-medium);
}
#section-personal-data {
  margin: 0 -12px 0 0;
}
.table {
  margin: 0;
}
.table td,
.table th {
  vertical-align: middle;
}
.table th {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
  text-align: start;
}
thead.thead {
  border-color: var(--blue-light);
}
tbody tr:nth-last-child(even) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}
tbody tr:nth-last-child(odd) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}
.btnGreen,
.btnRed {
  color: var(--white);
  padding: 6px 20px;
}
.btnRed {
  background-color: var(--red-medium);
}
.btnGreen {
  background-color: var(--green-medium);
}
.bl-dados {
  margin-right: 12px;
}
.bl-status {
  margin-left: 12px;
}
.disassociate {
  border-top: 8px solid var(--red-medium);
}
.associate {
  border-top: 8px solid var(--green-medium);
}
.btnDisassociate {
  background-color: var(--red-medium);
}
.btnAssociate {
  background-color: var(--green-medium);
}
@media only screen and (max-width: 700px) {
  #section-personal-data > div {
    flex-direction: column;
  }
}
@media only screen and (max-width: 768px) {
  .session-one {
    flex-direction: column;
  }
  #section-personal-data {
    margin: 0 0 12px 0;
  }

  .bl-dados {
    margin-right: 0;
  }
  .bl-status {
    margin-left: 0;
  }
}
</style>
